/**
 * Scheme allowlist for URLs that reach an href, an iframe src or window.open (#275).
 *
 * `new URL()` alone accepts `javascript:` and `data:`, so parseability is not a
 * safety check. API-supplied URLs (IT Glue record links, PDF links) must pass
 * through here before they are rendered.
 */

const DEFAULT_SCHEMES = ['http:', 'https:'];

export function isSafeUrl(value, allowedSchemes = DEFAULT_SCHEMES) {
  if (typeof value !== 'string' || !value) return false;
  try {
    return allowedSchemes.includes(new URL(value).protocol);
  } catch {
    return false;
  }
}

/** The URL itself when safe, otherwise undefined (an <a> without href is inert). */
export function safeHref(value) {
  return isSafeUrl(value) ? value : undefined;
}
